import { useEffect, useState } from "react";
import {
	connectWallet,
	getBasicInformations,
	getCurrentWalletConnected,
	mintNFT,
	getMintingStatus,
	verifyChainId
} from "./utils/interact";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import axios from "axios";
import Countdown from 'react-countdown';
import CountdownApi from 'react-countdown';
import React from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { renderIntoDocument } from "react-dom/test-utils";
import md5 from "md5";



const Minter = (props) => {
	//State variables
	var theCurrentSupply = 2000;


	const [walletAddress, setWallet] = useState("");
	const [status, setStatus] = useState("");
	const [currentSupply, setCurrentSupply] = useState("2000");
	const [mintingStatus, setMintingStatus] = useState(false);
	const [mintAmount, setMintAmount] = useState("1");
	const [mintingText, setMintingText] = useState("Minting");
	const [currentCost, setMintingCost] = useState("0.01");
	const [maxMintAmount, setMaxMintAmount] = useState("1");
	const [currentTime, setCurrentTime] = useState(1639429200000);
	const [currentRoundName, setCurrentRound] = useState("Presale");
	const [modalState, setModalState] = useState(false);
	const [mintingPassword, setMintingPassword] = useState("");
	let countdownapi = null;

	

	function checkWhitelist()
	{
		return true;
				var test = ["0xb911119cB87A6F07597B32Fc189962C8f324123A","0xC8f1955a879bbe7289CC1a2D86E05D36B6662D7F","0x7bed7521E3A4Bf0f34E137fe1F91A3B00D0087Cd","0x070abdFE500e8e9b92a06BD4b7c12fD934F244b6","0x6fFf154A5130aA757B57A5ec7D8111E01E020b40","0xd204bbbB87dEd6611A8CF6cC9C2c84C08866648e","0xEff610e17aE9f7155d293D36189d90b3fDe182AB","0x3612d2b5f2957086A0E86156921B18791256679C","0x4fD5B4a5Bc2E10a70E8DF32fAA3Bf55006594B68","0x6eb5DC8De8D69F3ab056333ab78cEc8059DDe67a","0x712d2f683423C933EC803796CBAe790A4d164066","0xc048202b634d5E08d0cc4D446dD040d0b9410254","0x3b894523A7E8e9f8D1e9EcA631F98E2bA5d849D0","0xd4071560706f78063530076f9147AfE3edC5F771","0x9BB03B2690a7bBfa93d3e445b72EC6eDF01613d3","0x22923f9399601b62a3f0Ea09211E5271dcB56aFA","0xee221fB2cc2fBC95cAF7138d3350B937f6E82215","0x28Cd8e1a610e056f1021fBD7E58b6d7Fef300e75","0x58A0083bd5E754bEF5FaCa512e7cB20A5352cE01","0x93991A65cB461Dd113Cf8AC6597c6661dAd7FeBF","0x4205913A62516EECB5ff97331bB5BedAa5F67E59","0xC79B405d5d4fc9D72992E17A0bC3f2d08c10a84C","0x39A1D744dE74ecf72253CA58a3012Dd739304fC1","0x95FB3410e72E88E4f77D2734B4E4D282138Db31E","0xbE30aA9aF6f62366De0DF61D01cDFb1cdc8a429e","0x244527CfAB8D1da4d0C8Ea9277C584228bcBEf39","0x46fcde783da5606042992ddceAd5d99A3bCFe764","0x9994eA8fe74348caC5d327c3857AE5B58983764F","0x9CC0e83BFc355E8EEE1070576B688A53E4d2F8B0","0x4000eF689587c4A66Bfa1f95321c29eF25b434b1","0x1A37a10F6325e4002ddcB287ba1AF4472746f76E","0xe028E35FAacE41C75cf9C6287a7d70b5b3Da852d","0x4496628962f1F7Fa893bfcfdEdf88d2bbF2AF1c4","0xD3A9DE208EDCFa22d0A7F22b188D5996b35e572f","0xbe728895c325F844699230227c13c56E259381Cc","0x7ddd33CCFCAF8D03B17427Fcf32c27bfd6779Fd2","0x4bfC0e7e3793B4A6aAA4dd4b318D922EdA963CEe","0xf3700C157A60F75d2D7E1DD1a0b1279B629a56cb","0x37B17dCdD5E28117599beC1F21dCab34D70d8142","0x258dD7E13674E8Be0BAE35027F4aFF2aF3Bac207","0xbD10C3201187014d6e53F92142f56507d40707e8","0x4d08cFfc00Cc52d800659d62821cD2CEb8d88B9b","0x17Da25bf92b7fc78Fa3095D38f26dB003691571d","0x3693E507a3E386004EF7b02801FcA87181E0FD68","0x649d95F8655b8b2Ea89415d487535adf68297344","0x9ffd8E89CFb99c2c0Cd1665280d846E51d8Dd8BE","0x7a2b8a56FFd2fD72eD11F910fc7EF98Cce0F0B72","0x1DeF992141B8Dba5afB0C63EcA9164C71a9312f9","0xdB0A0766029051F85A55Fc43FCA682DA3b9c1060","0x75322CdacdAF1F5e790CB88814346EcC746c5802","0x65E7CB1cC512D2de3eABfbF33bBAf14ab453Cd38","0xd7963c15A9C987b4885569EE7dE027E9A366604D","0x1d2CacC3BCb0b7Ae12C52d2a83A58222558d3494","0x4B425Ac21E73B4f40E53A39f99f6966DF4332633","0x69905e5627780eA6A65fD3A0Ae16e6d97af9f6dB","0xC1eAE831c306667Ea3a65B05f993A6A7048475A2","0x85965FCaB65c602887C48EA407fd5583E2291E1C","0x3F3BE7be2f879a7Dd1807cddA8Cf29b2bfF7CcA1","0x88A119e98faB2022deB063a4B1250518a2CAF712","0x53EE32D0bD98F69826d2853C3c6aebC7c4c8eF14","0xDa2c00ecf16bf1355fd0B9dAc929CF2afFd06d27","0x4d87eac741f89307F8b86472D85F5CA34fdC4484","0x7574dF634D6DAeef0c2e46Cc9F8F86491a8CBB75","0x30aefe223c3d1E170FfCb8c326F26083A6ec710d","0x877952035aBdEcEe6B5ac9BD53AF9750AA7Aa9FA","0x2C2f6d2CA32104312Fa97224363Fd0fF3F5Af9C8","0x6cdD6e35EE7282B3b0c415A964159c28a0dCae6D","0xeC72a312E7eB49824127D2F1663741Aee0d55f16","0x3d157c57871E270BC70ebc962F90894ffd228975","0xb42D2e81185B5AA1DBC437F8Ef12D3E56f8dCd69","0xa9945B748d54C0109B651B17b4a8bE0E113492b0","0x6ed88D68916DAadA0dEc867e40990E86163E0343","0x4f1A8864AC33813b2192F1f542aB15f8c31b4318","0x31c477dADD0Cf1ce949C1926841E9CE2f3b5742d","0xa112870b8d6C933888df4f76A2C804BEF9C098B1","0x52a256c00b626D8d00a4ca8D3c23c32EF451FafB","0x6E8DF99Aef3762DD37Ee0c9Bd1D4f2413D016af7","0xD551076646DDAeCa92810c31bC42da56204310B0","0x1fCca6CcB88AFBc361f0e2a7BFd0AF7d737548c3","0xf61E00c6BcB8Cc61c9519bbDDb05e31e627C9cb1","0xDAae54934f616FAadaF2abAb666EeB02245892e9","0x31356F6d29aec5c0f3F059a64d2A15622ae775D3","0xdDd596966873C198120060c12CDb0fdF403C60d8","0x4B153e99Af01cC033dA8911a790a7f5205D19480","0x19802218b854c5267961384fc1e310846a0bd352","0x03261850992D1381179d5Dd2B902eD94b9322374","0xE95f55A3E9554Cb041201E20FFe7638a762A2a67","0x3f1b603e3dadb7490f1bf45c4a1acf511855a858","0x01843729aA43E0FfB627AF81B61e264670209042","0xaaf2f565a9996e1b8be807c42a439e6e168efad5","0xaF0f398dB1715b0c80B4568d12CDC00d9f9a03dD","0x26e69Ac490D8d06280B0E90853B9dD7e38998F3F","0xf7Be02ddcF27E6D4314ac2C2441affC35640FdDc","0x17087c293fc01917BE2689E6551A55891a19119f","0x88a637F9Cb3141798A319d21f467E86e2A8e086b","0xBEA28617CF5757be6cabC36Ca9CDa266DDe9325F","0x254B8073B057942235756B7E7249fB5Ca60753Ef","0x7Bf5f796E22E908E32068B42f6e1e7e2a2Ffce55","0x0671EcFa289c70B15F87B82Cb53e88d51afb93E0","0x583C040607da037592Da1399F1fC2cb44Eb81d4B","0x4b2ef7127640964Bf5CEf3d1Bf8D8F72d8D386f5","0xAD13278655340CaaC447506A327598E0027CEE34","0xE3Ef16784B61cc41e8234CFf25e3f47E2Cbc5550","0x3118fBe9dDfD9bA217a0BD0c39CAc257Fec022b9","0x34C592F18B55c3f4Cc8056e717933CD807aE72B0","0x4E53Bd121371e2a96B0d6b48b57b1E9b7B0E5b02","0xF99ea6E9A98dEdCfb1ACC03225Fb9017544693E1","0x31c7c6269e33cf8c58719d7724808562ddce6ede","0xfF75451510DF6Ad50E902fFb2A295b96219b088f","0x4530d490f8de62e8Ce1a1A4E45Ae7F157236C9F5","0x66189De0FBc3d42193E3Ce09efFfB73A9C9B3100","0x794603C1a0c4799b04Cd8F9406D2b201286CE63A","0xb63Dca47C565B213BD2692B4d6832CcF96C513D0","0x0068166A7F79f1e6CaB481Abab827A322055487e","0x5cD5dFbCc4eE53B51d2d4B4E1230c707A1769846","0xE7bE36eB97D719D135a93C1C95c23a4D5C5e5C8E","0xAb8F9b1Ef49EEe423dB58bAaDe25E6d095A9E73E","0xC193d0FCA7C4C4557F5640a86c175D0a11D04c03","0xb5F966Ab3AD40e8Ef90ce660A91F3Ad16A211680","0x6c2f39dF4e989172647E033bB1ECB79eE91e67D7","0x95C15D1ddA7C8b1ed68a70e31AF5E80551217607","0x0AA98D3CdC335daCF4778E4DA043172832E1b045","0xd5623CFe7B351AAA5bdf08adb927Bfa9329A449C","0x9fD5aA7B4Ce70D7eB14f5233a756dF6ED0E8Cf79","0x94c330d1D95c209b7775504e21CF25A4b1506c78","0xAcCB9e02E2ecf1c59960588Ac48DA6540a875469","0x871E527FeB155e5ee0c638fA841Eb457340bdE45","0x872f3954C555b21dbC5E1D8b72fBeED122359885","0xed01D36c1e315bb44b83d28bd78e78fFAE907ecf","0x49c5e1236a202462A0eE30fa525814468488CEc8","0xcC0B05f4928518b2E160F149ca2a2FCaB77EA946","0xc492007f04bF3Eb00c9c126De5C7545906a14b2E","0x19d84D2A266c88AF9c42Cc2C6C8f27fD2CF1ed73","0x527dDa827f0D0B140fD4294Bc2F0B1918FC805bD","0x8d62825DD307EacFD35Bee137b654cb1016504a0","0x6a56E0DB17FdEC886437048Bd365791708a49490","0x9f2658B7Ae9b17E141f1376085d20c2C29E635A0","0xDf24d2f8C3C391086936825C99065B9a17E58173","0xB2fFfb62252894D27420994A655F732709a1D4E6","0xEeA7A70f90Cc24274C84365570F1c15789CC2b12","0xf37bca35AbEff7A3507e23b5aaC549B89dcB2F64","0x1EfB0128544940fcEC406a650EB918944034eE51","0x7153d3d101b8d46e045dcd7619b5b4c31a92a441","0xc28fa41bcc3964fa784e2793e3915fe4d4df8d3e","0xf18300a123ee66c2fa89153c95d28361817dc400"]
			var foundIt = false;
			
			for (var x = 0; x < test.length; x++) {
				if (test[x].toLowerCase() == walletAddress.toLocaleLowerCase()) {
					foundIt = true;
					break;
				}
			}
			
			return foundIt;

			
	}




	//1639429200000

	function showModal()
	{
		setModalState(true);
	}

	function addWalletListener() {

		if (window.ethereum) {

			window.ethereum.on("accountsChanged", (accounts) => {
				if (accounts.length > 0) {
					setWallet(accounts[0]);
				} else {
					setWallet("");
					notify("Connect to Metamask using the Connect Wallet button.");
				}
			});

			window.ethereum.on("chainChanged", (chainId) => {
				if(verifyChainId().status == false)
				{
					toast.error("You are connected to the wrong network!");
				}
			});

		} else {
			notify(
				<p>
					<a target="_blank" href={`https://metamask.io/download.html`}>
						You must install Metamask, a virtual Ethereum wallet, in
						your browser. Click here to install
					</a>
				</p>
			);
		}
	}



	const notify = (msg) => toast.info(msg);



	useEffect(async () => {


		setTimeout(verifyChainId,2000);

			const { address, status } = await getCurrentWalletConnected();

			setWallet(address);
			notify(status);
		


		setTimeout(startMinting,500);


		  refreshInformations();

		addWalletListener();
	}, []);






async function startMinting()
{
  if(document.getElementById("mintingStatus").innerHTML.indexOf("Minting") >= 0)
  {
    setTimeout(refreshMintingStatus,1000);
    setTimeout(refreshInformations, 1000);
  }
  else
  {
    setTimeout(startMinting,2000);
  }
}




	const renderer = ({ days, hours, minutes, seconds, completed }) => {
		if (completed) {
			return <Completionist />;
		} else {
			// Render a countdown
			return (
				<span>
					{days}:{hours}:{minutes}:{seconds}
				</span>
			);
		}
	};



	const Completionist = () => {
    return mintingText;
  }

	const  setRef = (countdown ) => {
    if (countdown) {
      countdownapi = countdown.getApi();
    }
  };

	async function refreshInformations() {
		try {
			const theResponse = await getBasicInformations();
			theCurrentSupply = theResponse.currentSupply;
			setCurrentSupply(theResponse.currentSupply);
			setMintingCost(theResponse.currentCost);
			setMaxMintAmount(theResponse.maxMintAmount);
			setCurrentTime( new Date( Number(theResponse.currentTime) ));
			setCurrentRound(theResponse.currentRoundName);
			setMintingPassword(theResponse.roundPassword);

			countdownapi.start();
		} catch(e){
			console.log(e);

		}

		setTimeout(refreshInformations, 2000);
	}

	async function refreshMintingStatus() {
		try 
		{
			const theResponse = await getMintingStatus();

			setMintingStatus(theResponse.mintingStatus);
			if(theResponse.mintingStatus == true)
			{


				if(parseInt(theCurrentSupply) > 0)
				{
					setMintingText("Minting...");
				}
				else
				{
					setMintingText("Sold out");
				}
				
			}
			else
			{
				setMintingText("Sale Ended");
			}
		}
		catch {
			console.log("Error");
		}

		setTimeout(refreshMintingStatus, 5000);
	}

	function handleMintAmount(e)
	{
		setMintAmount(e.target.value);
	}

	const connectWalletPressed = async () => {
		if((await verifyChainId()).status == true)
		{
			const walletResponse = await connectWallet();
			notify(walletResponse.status);
			setWallet(walletResponse.address);
		}
	};
	
	function createElements(number){
		var elements = [];
		for(var i =1; i <= maxMintAmount; i++){
			elements.push(<option value={i}>{i}</option>);
		}
		return elements;
	}

	const onMintPressed = async () => {


		if((await verifyChainId()).status == false)
		{
			return;
		}

		if(mintingPassword.length > 5)
		{
			let mintingPasswordBox = document.getElementById("mintingPasswordBox").value;
			if(mintingPasswordBox == "")
			{
				toast.error("Enter the minting password");
				return;
			}
			if(md5(mintingPasswordBox) != mintingPassword)
			{
				toast.error("Wrong password");
				return;
			}
		}




		if(walletAddress.length == 0)
		{
			notify("Please connect the wallet first");
			return;
		}


		/*if(currentRoundName.replace("-","").replace(" ","").toLowerCase().indexOf("presale") >= 0)
		{
			var foundIt = checkWhitelist();
			if (!foundIt) {
				toast.error("You're not in the whitelist");
				return;
			} else {
				toast.success("Whitelist User! Minting commencing...");
			}
		}*/


		
		if(parseInt(mintAmount) > parseInt(maxMintAmount))
		{
			notify("You can only mint " + maxMintAmount + " NFTs at a time!");
			return;
		}
    if(document.getElementById("mintingStatus").innerHTML.indexOf("Minting...") >= 0)
    {
		const { status } = await mintNFT(mintAmount,currentCost);
		notify(status);
    }
	else if(document.getElementById("mintingStatus").innerHTML.indexOf("Sold out") >= 0)
	{
		toast.error("We're sold out for the current round, please check back later!");
		return;
	}
    else
    {
		toast.error("Minting is not live yet! come back when the count down is over");
    }

	};
	return (
<div>

<header className="header">
        <nav className="navbar navbar-expand-lg fixed-top" id="navbar-sroll">
            <div className="container">
                <div className="d-flex align-items-center">
                    <a className="navbar-brand" href="index.html" data-aos="fade-right">
                        <img className="lazy" data-src="assets/img/png/logo-light.png" alt="I AM FLY" width="218" height="146"/>
                    </a>
                </div>
                <div className="collapse navbar-collapse" id="menuCollapse">
                    <ul className="navbar-nav ms-auto me-auto">
                        <li className="nav-item">
                            <a href="index.html#home" className="nav-link" aria-current="page">Home</a>
                        </li>
                        <li className="nav-item">
                            <a href="index.html#about" className="nav-link">About</a>
                        </li>
                        <li className="nav-item">
                            <a href="index.html#story" className="nav-link">Story</a>
                        </li>
                        <li className="nav-item">
                            <a href="index.html#nft" className="nav-link">Our NFTs</a>
                        </li>
                        <li className="nav-item d-none">
                            <a href="index.html#faq" className="nav-link">Faqs</a>
                        </li>
                        <li className="nav-item">
                            <a href="index.html#team" className="nav-link">Team</a>
                        </li>
                        <li className="nav-item">
                            <a href="index.html#roadmap" className="nav-link">Roadmap</a>
                        </li>
                        <li className="nav-item">
                            <a href="index.html#whitelist" className="nav-link">Whitelist</a>
                        </li>
                    </ul>
                </div>
                <div className="d-flex header-right">
                    <div className="d-flex align-items-center">
                        <button onClick={connectWalletPressed}  className="btn btn-primary rounded-pill"><span>{walletAddress.length > 0 ? (
                        "Connected: " +
                        String(walletAddress).substring(0, 6) +
                        "..." +
                        String(walletAddress).substring(38)
                    ) : (
                        <span>
                            Connect Wallet
                        </span>
                    )}</span></button>
                    </div>
                    <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#menuCollapse" aria-controls="menuCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <img className="icon menu lazy" data-src="assets/img/svg/menu.svg" alt=""/>
                        <img className="icon close lazy" data-src="assets/img/svg/close.svg" alt=""/>
                    </button>
                </div>
            </div>
        </nav>
    </header>
    <div className="main-content">
        <section className="mint">
            <div className="container">
                <div className="row">
                    <div className="col-lg-10 offset-lg-1">
                        <div className="form-wrapper text-center">
                            <div className="blur"></div>
                            <div className="img-wrapper">
                                <img className="lazy" data-src="assets/img/nft.gif" data-aos="fade-up" width="314" height="314"/>
                            </div>
                            <div className="status text-white">
                                <div className="d-md-flex justify-content-between align-items-center" data-aos="fade-up">
                                    <div className="mb-3 mb-lg-4">
                                        <h5>Status</h5>
                                        <h2 className="display-6 mb-0" id="mintingStatus"><Countdown
                autoStart={false}
                //
                    date={currentTime}
                    renderer={renderer}
                    ref={setRef}
                    
                /></h2>
                                    </div>
                                    <div className="mb-3 mb-lg-4">
                                        <h5>Round</h5>
                                        <h2 className="price mb-0">{currentRoundName}</h2>
                                    </div>
                                    <div className="mb-3 mb-lg-4">
                                        <h5>Price</h5>
                                        <h2 className="price mb-0">{currentCost}</h2>
                                    </div>
                                    <div className="mb-3 mb-lg-4">
                                        <h5>Remaining</h5>
                                        <h2 className="mb-0">{currentSupply}</h2>
                                    </div>
                                </div>
                            </div>
                            <form action="#" data-aos="fade-up">
                                <div className="d-md-flex justify-content-center align-items-center">
                                    <div className="form-group me-md-5 mx-auto ms-md-0 mb-4 mb-md-0 w-100">
                                        <div className="select-arrow">
                                            <select onChange={handleMintAmount} className="form-select" aria-label="Default select example">
                                                <option selected="" value="1">Select Mint Value...</option>
												{
                  createElements()
              }
                                            </select>
                                        </div>
                                    </div>
                                    <button className="btn btn-primary rounded-pill btn-mint" onClick={onMintPressed}>Mint Now</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="object"></div>
            <div className="object object-right"></div>
        </section>
    </div>
    <footer className="footer">
        <div className="container">
            <div className="text-center">
                <img data-aos="fade-up" className="logo lazy mb-4" data-src="assets/img/png/logo-light.png" width="360" height="240" alt=""/>
                <ul className="social">
                    <li><a href="https://twitter.com/bluefusionnfts" target="_blank"><img src="assets/img/png/twitter.png" alt=""/></a></li>
                    <li><a href="https://discord.gg/8evuPnsX" target="_blank"><img src="assets/img/png/discord.png" alt=""/></a></li>
                    <li><a href="https://www.instagram.com/bluefusionnfts" target="_blank"><img src="assets/img/png/instagram.png" alt=""/></a></li>
                </ul>
                <p className="copyright">Copyrights © 2022 Blue Fusion Collections</p>
            </div>
        </div>
    </footer>

	<ToastContainer autoClose={5000} />
</div>
	);
};

export default Minter;


